export default __webpack_public_path__ + "static/media/350-in-Sand-1-point5-768x511.bf0fbd3c.jpg";